// Turn nested tokens into { '--color-blue-100': '#aef2fd', ... }
export function flattenTokens(obj, prefix = []) {
    const out = {};
    for (const [k, v] of Object.entries(obj || {})) {
      const next = [...prefix, k];
      if (v && typeof v === 'object' && !Array.isArray(v)) {
        Object.assign(out, flattenTokens(v, next));
      } else {
        const name = `--${next.join('-')}`; // e.g. --color-blue-100
        out[name] = String(v);
      }
    }
    return out;
  }
  
  // Apply vars to :root (or a specific element if you prefer)
  export function applyVars(vars, el = document.documentElement) {
    const style = el.style;
    for (const [key, val] of Object.entries(vars)) {
      style.setProperty(key, val);
    }
  }
  